/* this file added by Bearer Web Developer  */
import React from 'react';
import {  TextFieldProps } from '@mui/material';
import styles from './BearerSearchField.module.scss'; // added by Bearer Web Developer
import { useThemeMode } from '../../../../../states/contexts/theme';
type BearerTextFieldProps = TextFieldProps
    & { clear?: () => void } // extended by Bearer Web Developer
// inputProperties interface added by Bearer Web Developer
interface inputProperties {
    value?: string
    checked?: boolean
    onChange?: () => {}
    onClick?: () => {}
    disabled?: boolean
    placeholder?: string
    name?: string
}
const BearerSearchField: React.FC<BearerTextFieldProps> = ({ ...props }) => {

    // modified by Bearer Web Developer start
    const { inputProps, label, name, placeholder, clear, ...otherProps } = props;
    // added by Bearer Web Developer start
    const handleCloseClear = () => {
        if (clear) clear();
    }
    // added by Bearer Web Developer end
    const { theme } = useThemeMode();
    return (
        <div className={otherProps.disabled ? `${styles.disabled} ${styles.text_input}` : styles.text_input}  data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={`${styles.input_part}`}>
                <input {...inputProps} name={name || label?.toString()}
                    id={name || label?.toString()}
                    {...otherProps as inputProperties} placeholder={placeholder} />
                <>
                    {/* close clear button added by Bearer Web Developer start */}
                    {
                        props.value && !otherProps.disabled &&
                        <img className={styles.close_clear}
                            src={`/close-clear-black.svg`}
                            alt="" width={24} height={24}
                            onClick={handleCloseClear}
                        />
                    }
                    {/* close clear button added by Bearer Web Developer end */}
                </>
            </div>
            <img className={`${styles.search_item}`} src="/search-item.svg" alt="" width={20} height={20}/>
        </div>
    );
    // modified by Bearer Web Developer end
}
export default BearerSearchField;